import Vue from 'vue'
import Vuex from 'vuex'
import createMainStoreConfig from './main'

Vue.use(Vuex)

export default new Vuex.Store(createMainStoreConfig())
